import Vue from "vue"
import Loading from '@/components/widgets/Loading.vue'
import SortedTablePlugin from "vue-sorted-table"
import CustomerCreate from '@/components/customer/customer-create'
import CustomerInfo from "./customer-details"
import Paginate from "@/components/widgets/pagination.vue";
import { CUSTOMER_SOURCES } from "@/constants/customer-sources"

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default {
  components: {
    Loading,
    CustomerCreate,
    CustomerInfo,
    Paginate
  },
  data: function() {
    return {
      role: "",
      branch: "",
      loading: false,
      busy: false,
      sortBy: 'name',
      apiStatus: 'ไม่พบข้อมูล',
      currentPage: 1, 
      currentData: {},
      perPage: 8,
      totalItem: 0,
      sortDesc: false,
      keyword: '',
      source: '',
      sourceOptions: [
        { value: '', text: 'แหล่งที่มาทั้งหมด' },
        { value: '__null__', text: 'ไม่มีแหล่งที่มา' },
        ...CUSTOMER_SOURCES
      ],
      create: {
        Id: null,
        mode: 'create',
        state: false
      },
      info: {
        Id: null,
        state: false
      },
      fields: [
        { 
          key: 'code', 
          label: 'รหัสลูกค้า', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
          sortable: true 
        },
        { 
          key: 'name', 
          label: 'ลูกค้า', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
        },
        { 
          key: 'address', 
          label: 'ที่อยู่',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top w-xs max-w-xs text-xs-1/2'
        },
        { 
          key: 'contact', 
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 text-xs-1/2',
          label: 'ติดต่อ' 
        },
        { 
          key: 'branch_name.name', 
          label: 'สาขา',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top w-xs max-w-xs text-xs-1/2'
        },
        { 
          key: 'action', 
          label: '#', 
          thClass: 'font-weight-bold text-xs-1/2',
          class: 'text-gray-400 text-right text-xs-1/2' 
        }
      ],
      items: []
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.onInitData(1)
    })
    this.getRole()
  },
  computed: {
    rows() {
      return this.items.length
    }
  },
  methods: {
    async getRole(){
      const res = await this.$store.dispatch('Auth/getRole', {}, { root: true })
      this.role = res.data.role
      this.branch = res.data.branch_id
    },
    oncreate() {
      this.create.Id = null
      this.create.mode = 'create'
      this.create.state = !this.create.state
    },
    onupdate(id) {
      this.create.Id = id
      this.create.mode = 'update'
      this.create.state = !this.create.state
    },
    onInfo(id) {
      this.info.Id = id
      this.info.state = !this.info.state
    },
    ondeleted(id) {
      this.$swal({
        width: "29rem",
        padding: '1.825em',
        html: '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
          '<div class="d-flex flex-column">'+
          '<span class="font-bold text-base py-2.5 text-left">คุณต้องการจะลบข้อมูลนี้หรือไม่?</span>'+
          '<span class="text-base text-left text-gray-500">หากคุณยืนยันแล้ว ข้อมูลจะไม่สามารถกู้คืนกลับมาได้?</span>'+
          '</div>'+
        '</div>',
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            popup: 'swal2-custom-rounded',
            closeButton: 'text-3xl swal2-custom-close',
            actions: 'justify-content-end',
            contant: 'd-flex flex-row justify-content-around px-2',
            title: 'd-none',
            confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
            cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
          },
          cancelButtonColor: '#dc4a38',
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: "ตกลง",
          showCancelButton: true,
          showCloseButton: true,
      }).then(async confirm => {
        if(confirm.value){
          this.loading = true
          this.onConfirmDelete(id)
        }
      })
    },
    handleCreateEvent(event) {
      if (event.status) {
        this.create.state = false
        setTimeout(() => {
          const currentPage = this.currentPage
          this.onInitData(currentPage)
        }, 500)
      }
    },
    handleInfoEvent(event) {
      if (event.status) {
        this.info.state = false
      }
    },
    async onConfirmDelete(id) {
      try {
        const param = {
          _id: id
        }
        const result = await this.$store.dispatch('Customers/delete', param, { root: true })
        if (result.status === 204) {
          this.loading = false
  
          this.$swal({
          width: "29rem",
          padding: '1.825em',
          html: '<div class="d-flex flex-row align-items-center">' +
            '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>'+
            '<div class="d-flex flex-column">'+
            '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>'+
            '<span class="text-base text-left text-gray-500">ลบข้อมูลเรียบร้อยแล้ว</span>'+
            '</div>'+
          '</div>',
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              popup: 'swal2-custom-rounded',
              closeButton: 'text-3xl swal2-custom-close',
              actions: 'justify-content-end',
              contant: 'd-flex flex-row justify-content-around px-2',
              title: 'd-none',
              confirmButton: "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
              cancelButton: 'btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal'
            },
            cancelButtonColor: '#dc4a38',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: "ตกลง",
            showCancelButton: false,
            showCloseButton: true,
          }).then(async confirm => {
            if(confirm.value){
              this.onInitData(1)
            }
          })
        }
      } catch (error) {
        this.loading = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onInitData(currentPage) {
      try {
        // this.items = []
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'
        const page = currentPage ? currentPage : 1
        const sourceQuery = this.source === '__null__'
          ? '&source_null=1'
          : (this.source ? `&source=${encodeURIComponent(this.source)}` : '')
        const url = `${Vue.prototype.$host}/api/v1/customer?page=${page}&perPage=8&keyword=${encodeURIComponent(this.keyword)}${sourceQuery}`
        const param = {
          keyword: this.keyword,
          url: url
        }
        const result = await this.$store.dispatch('Customers/search', param, { root: true })
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'

        if (result) {
          this.currentData = result.data;
          this.items = result.data.data
          this.totalItem = result.data.total
        } else {
          this.items = []
          this.totalItem = 0
        }
      } catch (error) {
        this.busy = false
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    }
  }
}
